import React, { FC } from 'react';
import { Button, Input, Multiselect } from '@cokitchen/cokitchen-components';
import { ReactComponent as AddIcon } from 'assets/icons/add.svg';
import { ReactComponent as SelectIcon } from 'assets/icons/select.svg';
import { CoKitchenType } from 'models/cokitchen.model';
import { STORAGE_KEYS } from 'utils/constants';

type PartnerHeaderType = {
  count: number;
  onClick: () => void;
  search: string;
  setSearch: (value: string) => void;
  selectedCokitchen: string[];
  setSelectedCokitchen: (value: string[]) => void;
};

const PartnersHeader: FC<PartnerHeaderType> = ({
  count,
  onClick,
  search,
  setSearch,
  selectedCokitchen,
  setSelectedCokitchen
}) => {
  const cokitchenArray: CoKitchenType[] = JSON.parse(
    localStorage.getItem(STORAGE_KEYS.COKITCHEN_LIST) || '[]'
  );

  return (
    <div className='flex max-lg:flex-col gap-4 justify-between lg:items-center'>
      <p className='font-semibold text-2xl'>Partners({count})</p>
      <div className='flex max-sm:flex-col gap-3 items-center'>
        <div className='cokitchen_multiselect flex items-center w-full'>
          <div>
            <SelectIcon className=' border-[#C4C4C4CC] ' />
          </div>
          <Multiselect
            placeholder='Cokitchens'
            onChange={setSelectedCokitchen}
            values={selectedCokitchen ?? []}
            options={cokitchenArray.map((p) => {
              return {
                text: p.name,
                value: p.id
              };
            })}
          />
        </div>

        <Input
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          small
          placeholder='Search partners'
          type='search'
        />
        <Button className='sm:!w-auto' small onClick={onClick} color='primary' variant='block'>
          <div className='flex justify-center items-center gap-3'>
            <AddIcon />
            <p>Add Partner</p>
          </div>
        </Button>
      </div>
    </div>
  );
};

export default PartnersHeader;
